module.exports = __webpack_public_path__ + "static/divider4.c64873de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg/divider4.jpg
// module id = 180
// module chunks = 58995536736497 275267278196080